"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateDivider = void 0;
const react_1 = __importDefault(require("react"));
const __1 = require("../../../../../..");
const Thread_styles_1 = require("../../../Thread.styles");
/**
 * Simple component that outputs a list item with a date inside
 *
 * Useful if we want to divide messages by date
 * @deprecated use <Thread.List> instead
 */
const DateDivider = ({ date }) => {
    return (react_1.default.createElement(Thread_styles_1.StyledDateDivider, { tabIndex: 0, role: "listitem" },
        react_1.default.createElement(__1.Text, { skinny: true }, date)));
};
exports.DateDivider = DateDivider;
//# sourceMappingURL=DateDivider.js.map